import { getActionHandler, getInitialState } from "../helpers/crudReducers";

const initialState = getInitialState("WATCHERS");
const CRUD_ACTION_HANDLERS = getActionHandler("WATCHERS");

export default function watchers(state = initialState, action) {
  const handler = CRUD_ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
